/* eslint-disable no-param-reassign */
import packageInfo from '../../../package.json';
import { PLUGIN_NAME } from './constants';

const { version } = packageInfo;

async function load(app) {
  app.log.debug('loaded list-query-variables-plugin');

  app.events.on(
    'plugin:page-builder:list:query-variables:sync',
    async ({ data = {}, props = {} }) => {
      const yachtListName = 'list-search-results-syd';
      const articlesListName = 'list-search-results-articles';
      const yfsListName = 'list-search-results-yfs';
      const yfcListName = 'list-search-results-yfc';
      const lists = [
        yfsListName,
        yfcListName,
        yachtListName,
        'list-search-results-brokers',
        'list-search-results-profiles',
        articlesListName
      ];

      const { name } = props;
      const { sort, rawQueryStringified } = data;
      if (
        !lists.includes(name) ||
        rawQueryStringified.includes('function_score') ||
        !sort.startsWith('_score')
      )
        return;

      const parsedRawQuery = JSON.parse(rawQueryStringified);

      // eslint-disable-next-line no-undef
      const queryShoulds = parsedRawQuery?.bool?.must[0]?.bool?.must[0]?.bool?.should || [];

      const {
        match: {
          name: { query }
        }
      } =
        queryShoulds.find(({ match }) => match.name) || {};

      const exactMatch = {
        match: {
          name: {
            query,
            boost: 20
          }
        }
      };

      queryShoulds.length = 0;

      queryShoulds.push(exactMatch);

      if ([yfsListName, yfcListName].includes(name)) {
        queryShoulds.push({
          match: {
            'publishedBuilderProfiles.name': {
              query,
              boost: 15
            }
          }
        });

        queryShoulds.push({
          match: {
            'publishedBrokers.name': {
              query,
              boost: 10
            }
          }
        });

        queryShoulds.push({
          match: {
            'publishedBuilderProfiles.name': {
              query,
              fuzziness: 'AUTO',
              prefix_length: 3
            }
          }
        });
      } else {
        const nameMatch = {
          match: {
            name: {
              query,
              fuzziness: 'AUTO',
              prefix_length: 3,
              boost: 10
            }
          }
        };
        queryShoulds.push(nameMatch);
      }

      if (name === yachtListName) {
        queryShoulds.push({
          match: {
            former_names_list: {
              query,
              fuzziness: 'AUTO',
              prefix_length: 3
            }
          }
        });
        queryShoulds.push({
          match: {
            former_names_list: {
              query,
              boost: 5
            }
          }
        });
      }

      let finalQuery = parsedRawQuery;
      if (name === articlesListName) {
        const articleProperties = [
          'metaTitle',
          'metaDescription',
          'metaKeywords',
          'tags.name',
          'category.name',
          'yacht_name'
        ];
        articleProperties.forEach(property => {
          queryShoulds.push({
            match: {
              [property]: {
                query,
                fuzziness: 'AUTO',
                prefix_length: 3
              }
            }
          });
        });

        finalQuery = {
          function_score: {
            query: parsedRawQuery,
            functions: [
              {
                gauss: {
                  date: {
                    origin: 'now',
                    scale: '30d',
                    offset: '7d',
                    decay: 0.3
                  }
                }
              }
            ],
            boost_mode: 'avg'
          }
        };
      }

      data.rawQueryStringified = JSON.stringify(finalQuery);
    }
  );

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
